import React from 'react'
import { cn } from './cn'

export interface StepListProps {
  /** Accessible name of the list, e.g.「運作方式」. */
  label: string
  steps: string[]
  className?: string
}

/** 一行排開的幾個步驟，前面是圓圈編號（推薦獎勵的「你分享連結 → 好友註冊 → 好友訂閱」）。 */
export function StepList({ label, steps, className }: StepListProps) {
  return (
    <ol
      aria-label={label}
      className={cn('m-0 flex list-none flex-wrap gap-x-5.5 gap-y-2 p-0 text-xs text-muted', className)}
    >
      {steps.map((step, index) => (
        <li key={index} className="flex items-center gap-1.75">
          <span
            aria-hidden="true"
            className="grid size-4.5 place-items-center rounded-full text-2xs font-semibold text-foreground shadow-[inset_0_0_0_1px_var(--border)]"
          >
            {index + 1}
          </span>
          {step}
        </li>
      ))}
    </ol>
  )
}
